import { render, staticRenderFns } from "./CertificationDetail.vue?vue&type=template&id=18adb8fe&scoped=true&"
import script from "./CertificationDetail.vue?vue&type=script&lang=js&"
export * from "./CertificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./CertificationDetail.vue?vue&type=style&index=0&id=18adb8fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18adb8fe",
  null
  
)

export default component.exports